import React from 'react';

const Loader = () => {
  return <div className="col-span-12">Loading...</div>;
};

export default Loader;
